import { useTranslation } from 'react-i18next'
import FrequentlyAskedQuestion from './FrequentlyAskedQuestion'

export default function FrequentlyAskedQuestions() {
  const { t } = useTranslation()

  return (
    <>
      <p className="custom-heading mb-8 text-[25px]">
        {t('components.faq.heading')}
      </p>

      <div className="space-y-6">
        <FrequentlyAskedQuestion
          text={t('components.faq.text1')}
          title={t('components.faq.title1')}
        />

        <FrequentlyAskedQuestion
          text={t('components.faq.text2')}
          title={t('components.faq.title2')}
        />

        <FrequentlyAskedQuestion
          text={t('components.faq.text3', {
            email:
              import.meta.env.VITE_SUPPORT_EMAIL ?? 'support@app-studio.ai',
          })}
          title={t('components.faq.title3')}
        />
      </div>
    </>
  )
}
